import React, { useState, useEffect } from 'react';
import './Breadcrumb.scss';
import { navigate } from '../../redux/actions/CourseActions';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import CuiIcon from '../CuiComponents/Icon';
import { useTranslation } from 'react-i18next';
import useXapi from '../../Hooks/useXapi';

const Breadcrumb = () => {
  const [isCrumbHidden, setIsCrumbHidden] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { xApiEvent } = useXapi();
  const {
    courseId,
    learningPathJson,
    currentModule,
    currentBlock
  } = useSelector(state => state.CourseState, shallowEqual);

  const Ellipsis = () => (
    <button className="ellipsis" onClick={() => setIsCrumbHidden(false)}>
      &#8230;
    </button>
  );

  // whenever the currentBlock changes, determine if we need to hide the currentBlock crumb
  useEffect(() => {
    setIsCrumbHidden(false);

    let breadcrumbSize = document
      .getElementById('breadcrumb-wrapper')
      .getBoundingClientRect();

    if (
      breadcrumbSize.height > 52 ||
      breadcrumbSize.width >= window.innerWidth - 16
    ) {
      setIsCrumbHidden(true);
    }
  }, [currentBlock]);

  return (
    <nav
      id="breadcrumb-wrapper"
      aria-label="breadcrumb"
      className={`breadcrumb-wrapper${
        courseId === currentBlock.li ? ' root' : ''
      }`}
    >
      {courseId !== currentBlock.li && (
        <ol className="breadcrumb">
          <li className="breadcrumb-item home">
            <a
              href={`/${learningPathJson['@id']}`}
              aria-label={t('Breadcrumb.home')}
              className="home-icon"
              onClick={e => {
                e.preventDefault();
                setTimeout(() => {
                  dispatch(navigate({ li: learningPathJson['@id'] }));
                  xApiEvent('Breadcrumb home clicked', window.location.href);
                });
              }}
            >
              <CuiIcon icon="home" />
            </a>
          </li>
          {currentModule && (
            <li>
              <span>{currentModule.name}</span>
            </li>
          )}
          {currentBlock && currentBlock.li !== learningPathJson['@id'] && (
            <li>
              {isCrumbHidden && <Ellipsis />}
              {!isCrumbHidden && <span>{currentBlock.name}</span>}
            </li>
          )}
        </ol>
      )}
    </nav>
  );
};
export default Breadcrumb;
